import React from 'react';
import { Modal, Input } from 'antd';

export default class EditModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleModalOk = this.handleModalOk.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.state = {
      modalInputValue: props.inputValue,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalInputValue: nextProps.inputValue,
    });
  }

  handleModalOk() {
    if (typeof this.props.onOk === 'function') {
      this.props.onOk(this.state.modalInputValue.trim());
    }
  }

  handleModalCancel() {
    if (typeof this.props.onCancel === 'function') {
      this.props.onCancel();
    }
  }

  handleInputChange(e) {
    this.setState({
      modalInputValue: e.target.value,
    });
  }

  render() {
    const { modalVisible, modalTitle, modalInputPlaceholder } = this.props;
    const { modalInputValue } = this.state;

    return (
      <Modal
        title={modalTitle}
        visible={modalVisible}
        onOk={this.handleModalOk}
        onCancel={this.handleModalCancel}
      >
        <Input
          value={modalInputValue}
          placeholder={modalInputPlaceholder}
          onChange={this.handleInputChange}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/EditModal.js